export function AttributeBoolean(): PropertyDecorator {
  return function (target: object, propertyKey: string): void {
    const valueStorage = '__ATTRIBUTE_BOOLEAN__' + propertyKey;
    Object.defineProperty(target, propertyKey, {
      get(this: any): any {
        return this[valueStorage];
      },
      set(this: any, val: any): void {
        let value: boolean;
        if (val === '') {
          value = true;
        } else if (val === 'false') {
          value = false;
        } else {
          value = !!val;
        }
        this[valueStorage] = value;
      },
    });
  };
}
